import { render, staticRenderFns } from "./GroupAssociateBuildingToTeam.vue?vue&type=template&id=55a46fa4&"
import script from "./GroupAssociateBuildingToTeam.vue?vue&type=script&lang=js&"
export * from "./GroupAssociateBuildingToTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports